"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composition_api_1 = require("@vue/composition-api");
var componentName = 'modal-popup';
exports.default = composition_api_1.defineComponent({
    props: {
        show: { type: Boolean, default: false },
        type: { type: String, default: 'confirmation' }
    },
    name: componentName,
    setup: function (props, context) {
        composition_api_1.watch(function () { return props.show; }, function (show, prevshow) {
            props.show ? document.body.style.overflow = 'hidden' : document.body.style.overflow = '';
        });
        var hasHeader = composition_api_1.computed(function () {
            return context.slots.header;
        });
        var hasActions = composition_api_1.computed(function () {
            return context.slots.actions;
        });
        return {
            hasHeader: hasHeader,
            hasActions: hasActions
        };
    }
});
